var _utils = (function(_utils) {

  // debounce: example usage:
  // var myEfficientFn = debounce(function() {
  //   // All the taxing stuff you do
  // }, 250);
  // window.addEventListener('resize', myEfficientFn);
  

  _utils.loadSVGasXML = function(SVGFile,callback){
      var loadXML = new XMLHttpRequest;
      function handler(){
        if(loadXML.readyState == 4 &&loadXML.status == 200){
          callback(loadXML.responseText);
        }
      }
      if (loadXML != null){
        loadXML.open("GET", SVGFile, true);
        loadXML.onreadystatechange = handler;
        loadXML.send();
      }
  }


  _utils.debounce = function(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this,
        args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };


  // Cookies

  _utils.createCookie = function(name, value, days) {
      var expires;
      if (days) {
          var date = new Date();
          date.setTime(date.getTime()+(days*24*60*60*1000));
          expires = "; expires="+date.toGMTString();
      }
      else {
          expires = "";
      }
      document.cookie = name+"="+value+expires+"; path=/";
  };

  _utils.readCookie = function(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
              c = c.substring(1,c.length);
          }
          if (c.indexOf(nameEQ) === 0) {
              return c.substring(nameEQ.length,c.length);
          }
      }
      return null;
  };

  _utils.eraseCookie = function(name) {
      _utils.createCookie(name,"",-1);
  };


  return _utils;
}(_utils || {}));




